export default [
    {
      path: "ExperienceAccount",
      name: "ExperienceAccount",
      meta: {
        title: "备考体验账号管理"
      },
      component: () =>
        import("@/views/Home/PineconeBusiness/ExperienceAccount/index.vue")
    },
  ];
  